enum PlayPauseState {
    Play = "PLAY",
    Pause = "PAUSE",
}

class HeroVideoPlayer {
    videoButtonId: string;
    videoId: string;
    playPauseState: PlayPauseState;
    videoPlayPauseButton: HTMLButtonElement;
    videoPlayer: HTMLVideoElement;

    constructor() {
        this.videoButtonId = "hero-play-pause-button";
        this.videoId = "hero-video";
        this.playPauseState = PlayPauseState.Play;
        this.videoPlayPauseButton = document.getElementById(
            this.videoButtonId,
        ) as HTMLButtonElement;
        this.videoPlayer = document.getElementById(
            this.videoId,
        ) as HTMLVideoElement;

        this.videoPlayPauseButton?.addEventListener("click", () => {
            if (this.playPauseState === PlayPauseState.Play) {
                this.setIsPaused();
            } else {
                this.setIsPlaying();
            }
        });
        this.handleReducedMotionPreference();
    }
    handleReducedMotionPreference() {
        if (!this.videoPlayer || !this.videoPlayPauseButton) return;
        const noMotionPreference = window.matchMedia(
            "(prefers-reduced-motion: no-preference)",
        );
        if (noMotionPreference.matches) {
            this.videoPlayer.setAttribute("autoplay", "true");
            this.setIsPlaying();
        } else {
            this.setIsPaused();
        }
    }
    setIsPlaying() {
        this.videoPlayer.play();
        this.videoPlayPauseButton.setAttribute("aria-label", "Pausa video");
        const img = this.videoPlayPauseButton.children[0] as HTMLImageElement;
        img.src = "/static/images/minstingen/pause.svg";
        this.playPauseState = PlayPauseState.Play;
    }
    setIsPaused() {
        this.videoPlayer.pause();
        this.videoPlayPauseButton.setAttribute("aria-label", "Spela video");
        const img = this.videoPlayPauseButton.children[0] as HTMLImageElement;
        img.src = "/static/images/minstingen/play.svg";
        this.playPauseState = PlayPauseState.Pause;
    }
}

export default HeroVideoPlayer;
